import { type ReactNode, type ButtonHTMLAttributes } from "react";

type ButtonVariant = "primary" | "secondary" | "text";

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:
    "bg-ink text-paper px-[18px] py-3 font-sans text-sm font-medium hover:bg-accentSoft transition-colors disabled:opacity-40 disabled:cursor-not-allowed",
  secondary:
    "bg-transparent border border-ink/25 px-[18px] py-3 font-sans text-sm font-medium text-ink hover:bg-ink hover:text-paper transition-colors disabled:opacity-40 disabled:cursor-not-allowed",
  text: "font-mono text-[10px] uppercase tracking-[0.18em] text-accent hover:text-accentSoft transition-colors",
};

/** Returns the Tailwind class string for a button variant.
 *  Use this when you need button styling on a non-button element (e.g. <Link>). */
export function buttonClasses(variant: ButtonVariant): string {
  return VARIANT_CLASSES[variant];
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: ButtonVariant;
  children: ReactNode;
}

export function Button({ variant, className = "", children, ...rest }: ButtonProps): ReactNode {
  return (
    <button type="button" className={`${VARIANT_CLASSES[variant]} ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}
